import * as Sentry from "@sentry/astro"

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENVIRONMENT,
  tracesSampleRate: 0.2,
  integrations: [],
})
